<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="500px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="320px">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title>
                           {{ formtitle }}
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              CCA Schedule
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2">Cancel</v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2">OK</v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-form ref="scheduleform" v-model="formvalid">
                  <v-row no-gutters>
                     <v-col cols="12" md="8" class="px-2">
                        <v-select
                           v-model="termyearselect"
                           :items="termyeardata"
                           item-text="termyeartext"
                           item-value="id"
                           label="Term/Year"
                           return-object
                           single-line
                           :rules="[(v) => !!v || 'Term/Year is required']"
                        >
                        </v-select>
                     </v-col>
                  </v-row>
                  <v-row no-gutters>
                     <v-col cols="12" md="12" class="px-2">
                        <v-text-field
                           label="Schedule Name"
                           v-model="edit_schedule_name"
                           required
                           :rules="[(v) => !!v || 'Name is required']"
                        >
                        </v-text-field>
                     </v-col>
                  </v-row>
                  <v-row no-gutters>
                     <v-col cols="6" md="6" class="px-2">
                        <datepicker-dialog
                           labelname="Start Date"
                           :indate.sync="edit_schedule_startdate"
                           @return-date="StartDateChange"
                        >
                        </datepicker-dialog>
                     </v-col>
                     <v-col cols="6" md="6" class="px-2">
                        <datepicker-dialog
                           labelname="End Date"
                           :indate.sync="edit_schedule_enddate"
                           @return-date="EndDateChange"
                        >
                        </datepicker-dialog>
                     </v-col>
                     <v-row no-gutters>
                        <v-col cols="12" md="8" class="px-2">
                           <v-checkbox
                              dense
                              v-model="edit_countcca"
                              label="Count As CCA"
                              :value="edit_countcca"
                           ></v-checkbox>
                        </v-col>
                     </v-row>
                  </v-row>
               </v-form>
            </v-sheet>
         </v-dialog>
      </v-container>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </div>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import DatepickerDialog from "./DatepickerDialog.vue";

   export default {
      inject: ["ShowMessage"],

      props: ["termyear"],

      components: {
         ConfirmDlg,
         DatepickerDialog,
      },

      data() {
         return {
            modal: false,
            termyeardata: this.termyear,
            formvalid: true,
            edit_schedule_termid: "",
            termyearselect: null,
            edit_schedule_name: "",
            edit_schedule_startdate: "",
            edit_schedule_enddate: "",
            edit_countcca: null,
            formmode: "add",
            formtitle: "",
         };
      },
      methods: {
         todayDate() {
            return this.$globalstore.currentDateISOString().substr(0, 10);
         },

         open() {
            this.formmode = "add";
            this.formtitle = "Add";
            this.termyeardata = this.termyear;
            this.termyearselect = null;
            this.edit_schedule_termid = "";
            this.edit_schedule_name = "";
            this.edit_schedule_startdate = this.todayDate();
            this.edit_schedule_enddate = this.todayDate();
            this.edit_countcca = true;
            this.formvalid = true;

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         edit(scheduledata) {
            this.formmode = "edit";
            this.formtitle = "Edit";
            this.termyeardata = this.termyear;
            this.termyearselect = this.termyeardata.find((x) => x.id == scheduledata.term_id);

            this.edit_schedule_id = scheduledata.id;
            this.edit_schedule_name = scheduledata.schedule_name;
            this.edit_schedule_startdate = scheduledata.schedule_startdate;
            this.edit_schedule_enddate = scheduledata.schedule_enddate;
            this.edit_countcca = scheduledata.count_cca == 1 ? true : false;
            this.formvalid = true;
            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         StartDateChange(date) {
            this.edit_schedule_startdate = date;
         },

         EndDateChange(date) {
            this.edit_schedule_enddate = date;
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         OkBtnClick() {
            if (this.$refs.scheduleform.validate()) {
               if (this.edit_schedule_startdate >= this.edit_schedule_enddate) {
                  this.ShowMessage({
                     title: "Error",
                     message: "End date must be greater than start date.",
                     color: "red",
                  });
                  return;
               }

               let payload = {
                  schedule: {
                     id: this.edit_schedule_id,
                     term_id: this.termyearselect.id,
                     termyeartext: this.termyearselect.termyeartext,
                     schedule_name: this.edit_schedule_name,
                     schedule_startdate: this.edit_schedule_startdate,
                     schedule_enddate: this.edit_schedule_enddate,
                     count_cca: this.edit_countcca,
                  },
                  mode: this.formmode,
               };
               this.resolve(true);
               this.modal = false;
               this.$emit("input", payload);
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Please complete the form.",
                  color: "red",
               });
            }
         },
      },
   };
</script>
